import { mutationOptions } from '@tanstack/react-query';
import { apiBaseURL } from '#constants/hosts';
import * as marketingConsent from '#proto/index.qonto.account_management.marketing_consent.firstparty.v1';
import { client, isResponseError } from '#queries/utils';

export const marketingConsentMutations = {
  leadConsent: mutationOptions({
    mutationFn: async ({ consent, email }: { consent: boolean; email: string }) => {
      await client(`${apiBaseURL}/v1/marketing_consent/lead_consents`, {
        method: 'POST',
        // TODO: use proto
        body: JSON.stringify({ consent, email }),
      });
    },
  }),
  update: mutationOptions({
    mutationFn: async ({
      data,
    }: {
      organizationId: string;
      data: marketingConsent.ApiUpdateClientConsentsRequest;
    }) => {
      const result = await client(`${apiBaseURL}/v1/marketing_consent/client_consents`, {
        method: 'PATCH',
        body: JSON.stringify(marketingConsent.ApiUpdateClientConsentsRequest.toJSON(data)),
      });

      return marketingConsent.ApiUpdateClientConsentsResponse.fromJSON(result);
    },
  }),
  globalUnsubscribe: mutationOptions({
    mutationFn: async () => {
      try {
        await client(`${apiBaseURL}/v1/marketing_consent/global_unsubscribe`, {
          method: 'POST',
        });
      } catch (error) {
        // 404 is expected when no consents exist — do not propagate
        if (isResponseError(error) && error.status === 404) {
          return;
        }
        throw error;
      }
    },
  }),
};
